<template lang="pug">
section.download
  .content
    h2.title {{ $t('download.title') }}
    .download__line
    a.button.button--corner.button--full-white.download__button(:href="getLink", target="_blank") {{ $t('download.button') }}
</template>

<script>
import env from "@godweb/frontend-base/src/libs/tools/Environment";

export default {
  name: "Download",

  computed: {
    getLink() {
      return `${env.getHomePage()}system`;
    },
  },
};
</script>
